import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiServiceApi {
  baseURL = environment.urlServerApi;
  header = new HttpHeaders();

  constructor(private http: HttpClient) {}

  postService(infoUrl: String, json: any): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.post(this.baseURL + infoUrl, json, {
      headers: this.header,
    });
    return info;
  }
  
  getService(infoUrl: String): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.get(this.baseURL + infoUrl, { headers: this.header });
    return info;
  }

}
